module.exports = __webpack_public_path__ + "3f86be9c5c61b01d664f3e3cfb0a36ba.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-768.webp
// module id = 477
// module chunks = 0